function showResponseBox2(formInfo) {
    setResponseTopPosition();

    $('#responseBox').unbind();
    window.recordRTkeys = 1;
    $('#responseBox').keypress(recordMultipleRT);

    window.enableEnter = trialHasButtonsActive(window.trialRow) ? 0 : 1;

    window.enableResponseWindowAfterMinimumDuration(disableResponseBox, enableResponseBox);

    setupInputBox(buttonsContainers[0], formInfo);

    var boxLeft = (canvasWidth / 2 - $('#responseBox').width() / 2);

    buttonsContainers[0].style.top = currentButtonTop + "px";
    buttonsContainers[0].style.left = boxLeft + "px";
    buttonsContainers[0].style.display = "block";

    //mutiple input boxes
    console.log('formInfo', formInfo.count);
    showOtherInputBoxes(formInfo.count);
    setupResponseBoxContainers();
    setupResponseBoxOptions();

    if(!formInfo.count){
        buttonsContainers[0].setAttribute("onkeydown", "");
        buttonsContainers[0].addEventListener("keydown", saveResponseBoxes, false);
    }
}


function setupInputBox(inputBox, formInfo) {
    inputBox.size = "20";
    inputBox.defaultValue = "";
    inputBox.value = "";
    inputBox.removeAttribute("maxLength");
    inputBox.placeholder = "";
    inputBox.readOnly = false;
    inputBox.required = false;

    if (formInfo.responseChoices.indexOf('size') > -1) {
        inputBox.size = formInfo.responseChoices[1 + formInfo.responseChoices.indexOf('size')].toString();
    }
    if (formInfo.responseChoices.indexOf('placeholder') > -1) {
        inputBox.placeholder = formInfo.responseChoices[1 + formInfo.responseChoices.indexOf('placeholder')].toString();
    }
    if (formInfo.responseChoices.indexOf('maxLength') > -1) {
        inputBox.maxLength = formInfo.responseChoices[1 + formInfo.responseChoices.indexOf('maxLength')].toString();
    }
    if (formInfo.responseChoices.indexOf('defaultValue') > -1) {
        inputBox.defaultValue = formInfo.responseChoices[1 + formInfo.responseChoices.indexOf('defaultValue')].toString();
    }
    if (formInfo.responseChoices.indexOf('readOnly') > -1) {
        inputBox.readOnly = true;
    }
    if (formInfo.responseChoices.indexOf('required') > -1) {
        inputBox.required = true;
    }

    //wait at least one event cycle to not carry key presses from previous trial
    if (!window.inPreviewMode) {
      window.setTimeout(function(){
          inputBox.focus();
      }, 0)
    }
}

function showOtherInputBoxes(count) {
    if(count > 1) {
        window.recordRTkeys = 0;
    }
    var rowLabels = listTrialResponseRowsLabels[window.trialRow];
    var boxLeft = (canvasWidth / 2 - $('#responseBox').width() / 2);

    var boxHeight = 34;
    var labelWidth = 200;
    var verticalMargin = 10;
    // var boxTop = currentButtonTop + (rowLabels.length - 1) * (34+verticalMargin);
    var boxTop = currentButtonTop + verticalMargin;

    if(rowLabels){
        labelBox.innerText = rowLabels[0];
        labelBox.style.display = 'block';
        labelBox.style.top = boxTop + "px";
        labelBox.style.left = boxLeft - labelWidth - 15 + "px";
        labelBox.style.lineHeight = boxHeight + "px";
    }

    for (var i = 0; i < count; i++) {
        if(rowLabels && rowLabels[i]){
            responseBoxesLabels[i].innerText = rowLabels[i];
            responseBoxesLabels[i].style.display = 'block';
            responseBoxesLabels[i].style.top = boxTop + i * boxHeight + i * verticalMargin + "px";
            responseBoxesLabels[i].style.left = boxLeft - labelWidth - 15 + "px";
            responseBoxesLabels[i].style.lineHeight = boxHeight + "px"
        }

        responseBoxes[i].value = '';
        responseBoxes[i].setAttribute("onkeydown", "");
        responseBoxes[i].addEventListener("keydown", saveResponseBoxes, false);
        responseBoxes[i].style.display = 'block';

        // responseBoxes[i].style.top = boxTop + i * boxHeight + i * verticalMargin + "px";
        // responseBoxes[i].style.left = boxLeft + "px";
    }
}

function setupResponseBoxOptions(){
    var options = getResponseBoxesOptions(columnForTrial('responseOptions', trialRow));
    const countBoxes = getInputBoxesForTrial(window.trialRow);
    for(var i = 0; i < countBoxes; i++){
        if(options["sum"] || options["min"] || options["max"]){
            responseBoxes[i].type = "number";
            if(options["min"]){
                responseBoxes[i].min = options["min"];
            }
            if(options["max"]){
                responseBoxes[i].max = options["max"];
            }
        }
        else{
            responseBoxes[i].type = "text";
        }

        if(options["width"]){
            responseBoxes[i].style.width = options["width"] + "px";
        }

        for(const option in window.listTrialBoxOptions[trialRow]) {
            responseBoxes[i][option] = window.listTrialBoxOptions[trialRow][option];
        }
    }
}

function getInputBoxesForTrial(trial){
    var responseType = columnForTrial('responseType', trial);
    if(responseType == 'box'){
        return 1;
    }
    else if(responseType.indexOf('box')<0){
        return 0;
    }
    else{
        responseType = responseType.split('*');
        if(responseType[1]){
            return parseInt(responseType[1]);
        }
        else{
            return 1;
        }
    }
}

function countMaxInputBoxes() {
    var maxBoxes = 1;
    for(var i = 0; i < noTrials; i++){
        var currentCount = getInputBoxesForTrial(i);
        maxBoxes = currentCount > maxBoxes ? currentCount : maxBoxes;
    }
    return maxBoxes;
}

function hideAndClearResponseBoxes() {
    for(var i = 0; i < responseBoxes.length; i++){
        responseBoxes[i].value = "";
        responseBoxes[i].removeEventListener("keydown", saveResponseBoxes);
        responseBoxes[i].style.display = "none";

        for(const option in window.listTrialBoxOptions[trialRow]) {
            responseBoxes[i].removeAttribute(option);
        }

    }

    resetResponseBox();
}

function getResponseBoxesResponse() {
    var response = "";
    var atLeastOneResponse = false;
    var response = responseBoxes[0].value.trim();
    if(response != ""){
        atLeastOneResponse = true;
    }
    const countBoxes = getInputBoxesForTrial(trialRow);
    for(var i = 1; i < countBoxes; i++){
        var currentResponse = responseBoxes[i].value.trim();
        response +=  ';' + currentResponse;
        if(currentResponse != ""){
            atLeastOneResponse = true;
        }
    }
    return response;
}

function saveResponseBoxes(event){
    if(event.keyCode === 13 && enableEnter === 1){
        var response = getResponseBoxesResponse();
        if(response){
            var optionsString = columnForTrial('responseOptions', trialRow);
            const boxOptions = listTrialBoxOptions[trialRow];
            error = verifyResponseBoxes(optionsString, boxOptions);
            if(error){
                displayResponseBoxesError(error);
                return;
            }
            saveTrial(response);
            clearTimeouts();
            $('#responseBoxError').remove();
            hideAndClearResponseBoxes();
            endTrial();
        }
    }
}

function displayResponseBoxesError(message){
    var $errorMessage;
    if($('#responseBoxError').length){
        $errorMessage = $('#responseBoxError');
        $errorMessage.text(message);
    }
    else{
        $errorMessage = $('<div>', {
            id: 'responseBoxError',
            text: message,
        });
        $errorMessage.css({
            'width': '100%',
            'text-align': 'center',
            'position': 'absolute',
            'top': (getStimuliBoundaries().bottom + 100) + 'px',
            'color': 'red',
            'font-size': '150%'
        });
    }
    $('#displayScreen').append($errorMessage);

}

function verifyResponseBoxes(optionsString, boxOptions){
    var options = getResponseBoxesOptions(optionsString);

    if(!requiredBoxesHaveResponse()) {
        return trans("boxes.required");
    }

    if(boxOptions['pattern'] && !verifyBoxPatternMatching()) {
        return trans("boxes.pattern");
    }

    if(!options){
        return;
    }

    if(options["sum"]){
        if(!verifyResponseBoxesSum(options["sum"])){
            return trans("boxes.sum");
        }
    }

    if(options["min"]){
        if(!verifyResponseBoxesMin(options["min"])){
            return trans("boxes.min")
        }
    }

    if(options["max"]){
        if(!verifyResponseBoxesMax(options["max"])){
            return trans("boxes.max");
        }
    }

    function requiredBoxesHaveResponse(){
        if(columnForTrial('required', trialRow) === "na"){
            return true;
        }

        const countBoxes = getInputBoxesForTrial(trialRow);
        for(let i = 0; i < countBoxes; i++) {
            const response = responseBoxes[i].value.trim();
            if(response === "") {
                return false;
            }
        }

        return true;
    }

    function verifyBoxPatternMatching() {
        const countBoxes = getInputBoxesForTrial(trialRow);
        for(let i = 0; i < countBoxes; i++) {
            if (responseBoxes[i].validity.patternMismatch) {
                return false;
            }
        }
        return true;
    }

    function calculateResponseBoxesSum(){
        const countBoxes = getInputBoxesForTrial(trialRow);
        var sum = 0;
        for(var i = 0; i < countBoxes; i++){
            sum += parseInt(responseBoxes[i].value.trim());
        }
        return sum;
    }

    function verifyResponseBoxesSum(expectedSum){
        const sum = calculateResponseBoxesSum();
        if(sum != expectedSum){
            return false;
        }
        return true;
    }

    function verifyResponseBoxesMax(expectedMax){
        const countBoxes = getInputBoxesForTrial(trialRow);
        for(var i = 0; i < countBoxes; i++){
            var currentValue = parseInt(responseBoxes[i].value.trim());

            if(!Array.isArray(expectedMax)){
                if (currentValue > expectedMax){
                    return false;
                }
            }
            else{
                if(expectedMax[i] && currentValue > expectedMax[i]){
                    return false;
                }
            }
        }
        return true;
    }

    function verifyResponseBoxesMin(expectedMin){
        const countBoxes = getInputBoxesForTrial(trialRow);
        for(var i = 0; i < countBoxes; i++){
            var currentValue = parseInt(responseBoxes[i].value.trim());

            if(!Array.isArray(expectedMin)){
                if (currentValue < expectedMin){
                    return false;
                }
            }
            else{
                if(expectedMin[i] && currentValue < expectedMin[i]){
                    return false;
                }
            }
        }
        return true;
    }
}

function getResponseBoxesOptions(optionsString){
    var optionsObject = {};

    var options = optionsString.split(';');
    //options are seperated by ;
    for(var i in options){
        //current option has format "option:value"
        var currentOption = options[i].split(':');
        if(currentOption[0] && currentOption[1]){
            optionsObject[currentOption[0]] = currentOption[1];
        }
    }
    return optionsObject;
}

function disableResponseBox() {
    window.enableEnter = 0;
}

function enableResponseBox() {
    window.enableEnter = trialHasButtonsActive(window.trialRow) ? 0 : 1;
}